import {
  Button,
  Flex,
  Popover,
  PopoverHeader,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import isEqual from 'lodash/isEqual';
import { useSelector } from 'react-redux';

import Pencil from 'components/Icons/Pencil';
import Plus from 'components/Icons/Plus';
import { getCalculationLoadingStatus } from 'redux/DashboardSliceV2';
import { STATUS } from 'projectConstants';

import IndicatorMultiSelector from './IndicatorMultiSelector';

export interface Properties {
  selectedIndicators: Array<any>;
  handleSubmit: (indicators: Array<any>) => void;
}

const SelectionPopover = ({ selectedIndicators, handleSubmit }: Properties) => {
  const [localIndicators, setLocalIndicators] = useState<Array<any>>([]);
  const isLoading = useSelector(getCalculationLoadingStatus);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (selectedIndicators.length > 0) {
      setLocalIndicators(selectedIndicators);
    }
  }, [selectedIndicators]);

  const handleAddIndicator = (indicator: any) => {
    const isSelected = localIndicators.some(
      (selected: any) => selected.indicator_id === indicator.indicator_id,
    );
    const wasPreviouslySelected = selectedIndicators.some(
      (selected: any) => selected.indicator_id === indicator.indicator_id,
    );
    let updatedIndicators = [...localIndicators];
    if (wasPreviouslySelected) {
      const previouslySelectedIndicatorIndex = selectedIndicators.findIndex(
        (selected: any) => selected.indicator_id === indicator.indicator_id,
      );
      if (previouslySelectedIndicatorIndex > -1) updatedIndicators = [...localIndicators];
      updatedIndicators.splice(
        previouslySelectedIndicatorIndex,
        0,
        selectedIndicators[previouslySelectedIndicatorIndex],
      );
    } else if (isSelected) {
      updatedIndicators = updatedIndicators.filter(
        (selected: any) => selected.indicator_id !== indicator.indicator_id,
      );
    } else {
      updatedIndicators.push(indicator);
    }
    setLocalIndicators(updatedIndicators);
  };
  const handleRemoveIndicator = (indicator: any) => {
    const updatedIndicators = localIndicators.filter(
      (selected: any) => selected.indicator_id !== indicator.indicator_id,
    );
    setLocalIndicators(updatedIndicators);
  };

  return (
    <Popover
      strategy={'fixed'}
      placement='left'
      direction='ltr'
      closeOnBlur={false}
      isOpen={isOpen}
    >
      <PopoverTrigger>
        <Button width={'14.583px'} onClick={() => setIsOpen(!isOpen)} variant='transparent'>
          {selectedIndicators?.length ? <Pencil color='#787878' /> : <Plus color='#787878' />}
        </Button>
      </PopoverTrigger>
      <PopoverContent bg='white' p={2} pl={1} borderRadius='sm' boxShadow='lg' maxW='md'>
        <PopoverArrow />
        <PopoverHeader fontWeight='bold' color='#6562CF' fontSize={'md'}>
          Select indicator
        </PopoverHeader>
        <PopoverBody p={3}>
          <IndicatorMultiSelector
            selectedIndicators={localIndicators}
            handleAddIndicator={handleAddIndicator}
            handleRemoveIndicator={handleRemoveIndicator}
          />
          <Flex justifyContent='flex-end' alignItems='center' p={2} gap={2}>
            <Button variant={'cancel_button'} onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button
              variant={'save_button'}
              onClick={() => {
                setTimeout(() => {
                  if (isEqual(selectedIndicators, localIndicators)) {
                    setIsOpen(false);
                  } else {
                    handleSubmit(localIndicators);
                    setIsOpen(false);
                  }
                }, 1000);
              }}
              disabled={
                !(isLoading === STATUS.SUCCESS || isLoading === STATUS.IDLE) ||
                !localIndicators ||
                !localIndicators?.length
              }
            >
              Apply
            </Button>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
export default SelectionPopover;
